import DotLoader from "react-spinners/BeatLoader";

const XLoaderWithoutStyle = () => {
    return (
        <DotLoader
            color="var(--color-primary)"
            loading={true}
            size={30}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
    )
}

export default XLoaderWithoutStyle